module.exports = __webpack_public_path__ + "img/youtube.d42d11c4.png";